import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
  footerButtonWrapper: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
})
